"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _chartUtils = require("../../chartUtils");

var _readingsToCoordinates = require("../../transformers/readingsToCoordinates");

var _CumulativeChart = _interopRequireDefault(require("./CumulativeChart"));

require("react-vis/dist/style.css");

var _hooks = require("../../hooks");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var transformToSiteCoordinates = (0, _memoizeOne["default"])(function (timeZone, readings) {
  return readings.filter((0, _chartUtils.isValidReading)('cumulativeKwh')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'cumulativeKwh'));
});
var transformToPeerAdjCoordinates = (0, _memoizeOne["default"])(function (timeZone, readings) {
  return readings.filter((0, _chartUtils.isValidReading)('cumulativePeer')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'cumulativePeer'));
});
var transformToContractGenerationCoordinates = (0, _memoizeOne["default"])(function (timeZone, readings) {
  return readings.filter((0, _chartUtils.isValidReading)('cumulativeContract')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'cumulativeContract'));
});

var CumulativeDailyChartContainer = function CumulativeDailyChartContainer(_ref) {
  var activeDataValues = _ref.activeDataValues,
      authToken = _ref.authToken,
      baseUrl = _ref.baseUrl,
      hasBattery = _ref.hasBattery,
      internalUsage = _ref.internalUsage,
      maxDateISO = _ref.maxDateISO,
      minDateISO = _ref.minDateISO,
      prospectId = _ref.prospectId,
      timeZone = _ref.timeZone,
      viewEndISO = _ref.viewEndISO,
      viewStartISO = _ref.viewStartISO;
  var cumulativeProductionV2 = (0, _hooks.useCumulativeProductionDailyV2)(prospectId, maxDateISO, baseUrl, authToken) || [];
  var cumulativePeer = (0, _hooks.useCumulativePeerDaily)(prospectId, minDateISO, maxDateISO, baseUrl, authToken, internalUsage) || [];
  var cumulativePeerV2 = (0, _hooks.useCumulativePeerDailyV2)(prospectId, minDateISO, maxDateISO, baseUrl, authToken, internalUsage) || [];
  var cumulativeContract = (0, _hooks.useCumulativeContract)(prospectId, minDateISO, maxDateISO, baseUrl, authToken, internalUsage) || {
    daily: []
  };
  var isContractLoading = (0, _hooks.useCumulativeContractLoading)();
  var isPeerLoading = (0, _hooks.useCumulativePeerDailyLoading)();
  var isPeerV2Loading = (0, _hooks.useCumulativePeerDailyV2Loading)();
  var isProductionLoading = (0, _hooks.useCumulativeProductionDailyV2Loading)();
  var isLoading = isContractLoading || isPeerLoading || isProductionLoading || isPeerV2Loading;
  var contractCoordinates = activeDataValues.includes('contract') ? transformToContractGenerationCoordinates(timeZone, cumulativeContract.daily) : [];
  var peerCoordinates = activeDataValues.includes('peer') ? transformToPeerAdjCoordinates(timeZone, cumulativePeer) : [];
  var peerV2Coordinates = activeDataValues.includes('peerV2') ? transformToPeerAdjCoordinates(timeZone, cumulativePeerV2) : [];
  var productionCoordinatesV2 = activeDataValues.includes('solar') || activeDataValues.includes('systemProduction') ? transformToSiteCoordinates(timeZone, cumulativeProductionV2) : [];
  return /*#__PURE__*/_react["default"].createElement(_CumulativeChart["default"], {
    contractCoordinates: contractCoordinates,
    hasBattery: hasBattery,
    isLoading: isLoading,
    peerCoordinates: peerCoordinates,
    peerV2Coordinates: peerV2Coordinates,
    productionCoordinates: productionCoordinatesV2,
    internalUsage: internalUsage,
    timeZone: timeZone,
    viewEndISO: viewEndISO,
    viewStartISO: viewStartISO
  });
};

CumulativeDailyChartContainer.propTypes = {
  activeDataValues: _propTypes["default"].arrayOf(_propTypes["default"].string),
  authToken: _propTypes["default"].string.isRequired,
  baseUrl: _propTypes["default"].string.isRequired,
  hasBattery: _propTypes["default"].bool,
  maxDateISO: _propTypes["default"].string.isRequired,
  minDateISO: _propTypes["default"].string.isRequired,
  prospectId: _propTypes["default"].string.isRequired,
  timeZone: _propTypes["default"].string,
  viewEndISO: _propTypes["default"].string.isRequired,
  viewStartISO: _propTypes["default"].string.isRequired,
  internalUsage: _propTypes["default"].bool
};
CumulativeDailyChartContainer.defaultProps = {
  activeDataValues: ['solar', 'peer', 'contract'],
  hasBattery: false,
  timeZone: 'local',
  internalUsage: false
};
var _default = CumulativeDailyChartContainer;
exports["default"] = _default;